import BaseApiService from "./base-services/baseApi.service";

class BlogApiService extends BaseApiService {
	constructor() {
		super();
	}

	blogDetailPage = async (slug) => {
		const url = `/website/blogs/blog-detail?slug=${slug}`;
		const res = await this.axiosInstance.get(url);
		return await res.data;
	};

	getBlogLists = async (page) => {
		const url = `/website/blogs/blog-list?page=${page}`;
		const res = await this.axiosInstance.get(url);
		return await res.data;
	};
}
const blogApiService = new BlogApiService();
export { blogApiService };
